import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const FormRadioGroup = () => (
  <ComponentDocs
    name="<Form.RadioGroup/>"
    entry="RadioGroup"
    propsEntry="RadioGroupProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiRadioGroup}
  >
    <ComponentExample
      name="Radio options"
      import={import("examples/Forms/FormRadioGroup/RadioOptionsExample")}
      rawImport={import(
        "examples/Forms/FormRadioGroup/RadioOptionsExample?raw"
      )}
    />
    <ComponentExample
      name="Inline radios"
      import={import("examples/Forms/FormRadioGroup/InlineRadiosExample")}
      rawImport={import(
        "examples/Forms/FormRadioGroup/InlineRadiosExample?raw"
      )}
    />
    <ComponentExample
      name="Lookup-connected radios"
      import={import(
        "examples/Forms/FormRadioGroup/LookupConnectedRadiosExample"
      )}
      rawImport={import(
        "examples/Forms/FormRadioGroup/LookupConnectedRadiosExample?raw"
      )}
    />
    <ComponentExample
      name="Linked radio groups"
      description="Multiple RadioGroup components can be mutually exclusive if they share the same field name. It is also possible to use the name prop to link them together."
      import={import("examples/Forms/FormRadioGroup/LinkedRadioGroupsExample")}
      rawImport={import(
        "examples/Forms/FormRadioGroup/LinkedRadioGroupsExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormRadioGroup;
